<template>
  <div
    v-if="showLoadMore"
    class="w-full center pt-8"
  >
    <div
      v-if="props.isLoadMore"
      class="progress my-8"
    >
      <div class="indeterminate"></div>
    </div>

    <Button
      ref="loadMoreRef"
      role="button"
      class="flex-auto"
      :class="{loading: props.isLoadMore}"
      :disabled="props.isLoadMore || props.productsPending"
      :label="$t('loadMore')"
      @click="loadMore"
    >
    </Button>
  </div>
</template>

<script setup>
const loadMoreRef = ref(null)
const targetIsVisible = useElementVisibility(loadMoreRef)

const page = ref(1)
const showLoadMore = ref(true)
const loadMoreTop = ref(0)
const stopScrolling = ref(false)

/**
* Props
*/
const props = defineProps({
  products: {
    type: [Object, Boolean, String],
    default: null
  },
  paramsProducts: {
    type: [Object],
    default: null
  },
  productsPending: {
    type: [Boolean],
    default: false
  },
  autoloading: {
    type: [Boolean],
    default: null
  },
  isLoadMore: {
    type: [Boolean],
    default: null
  },
  el: {
    type: [Object],
    default: null
  }
})

/**
* Emits
*/
const emit = defineEmits(['loadMoreProducts'])

/**
* Products Pending ref
*/
const productsPendingRef = computed({
  get() {
    return props.productsPending
  }
})

/**
* Disabled LoadMore
*/
const disabledLoadMore = ref(true)
watch(productsPendingRef, (newA) => {
  if (newA) {
    disabledLoadMore.value = true
  } else { 
    setTimeout(() => { 
      disabledLoadMore.value = false
    }, 500)
  }
}, { deep: true })

onMounted(() => { 
  if (productsPendingRef.value !== true) {
    setTimeout(() => {
      disabledLoadMore.value = false
    }, 500)
  }
})

/**
* Load More Products
*/
const loadMore = () => {
  if ((props.isLoadMore && productsPendingRef.value) || disabledLoadMore.value) {
    return false
  }

  /*
  * Loading Products
  */
  page.value = (props.products?._meta?.links.limit === props.paramsProducts.limit)
    ? props.products?._meta?.links?.page + 1
    : (props.products?._meta?.links?.limit / props.paramsProducts.limit) + 1

  /**
  * Update Products
  */
  emit('loadMoreProducts', {
    page: page.value
  })
}

/**
* Handle Scroll
*/
watch(targetIsVisible, (newA) => {
  if (newA && props.autoloading) {
    loadMore()
  }
}, { deep: true })

/**
* Scroll to New Products
*/
watch(productsPendingRef, (newA) => {
  if (newA) {
    disabledLoadMore.value = true
  } else { 
    setTimeout(() => { 
      disabledLoadMore.value = false
    }, 500)
  }

  loadMoreTop.value = loadMoreRef.value?.offsetHeight + useWindowScroll().y + 100

  setTimeout(() => { 
    stopScrolling.value = false
  }, 1000)
}, { deep: true })
</script>

<style lang="scss">
</style>
